import { useCappsSplitWebApiHandler_getTreatment } from '@zg-rentals/ts-capps-client-react-query';

export const RA_RACHEL_REQUEST_PAYMENTS = 'RA_RACHEL_REQUEST_PAYMENTS';
export type PaymentRequestTreatment = 'off' | 'on_1a' | 'on_1b' | 'on_2' | 'on_3';

export function getHasBetaCookie() {
  return (
    document.cookie
      .split(';')
      .find((cookie) => cookie.trim().startsWith('beta='))
      ?.split('=')[1] === 'true'
  );
}

export function useGetTreatment<T extends string = 'on' | 'off'>(featureName: string): T | 'off' | undefined {
  const { data: response, isError, isLoading } = useCappsSplitWebApiHandler_getTreatment({ featureName });
  if (isLoading) return undefined; // Still loading, but no error, so we just wait

  // The response should be fully defined here:
  if (
    // If the request failed
    isError ||
    // Or if the response is not a JSON object
    typeof response !== 'object' ||
    // Or if the response is not in the shape that we expect
    typeof response.treatment !== 'string'
  ) {
    // We fallback to "off"
    return 'off';
  }
  return response?.treatment as T;
}

export function usePaymentRequestTreatment() {
  return useGetTreatment<PaymentRequestTreatment>(RA_RACHEL_REQUEST_PAYMENTS);
}
